<template>
  <div
    class="QA"
    :style="{
      overflow: flag ? 'initial' : 'hidden',
      height: flag ? 'auto' : '43px'
    }"
  >
    <div class="qList">
      <div
        class="qItem"
        v-for="(item, index) in questions[position]"
        :key="index"
        @click="handleShow(index)"
      >
        <i class="icon_question"></i>{{ item.q }}
      </div>
      <div
        class="more"
        :style="{ right: showToggle ? '-120px' : '0px' }"
        @click="$router.push('/QA')"
      >
        更多问题与帮助>>
      </div>
    </div>
    <div class="qToggle" @click="flag = !flag" v-if="showToggle">
      展开问题与帮助 <i :class="`${flag ? '' : 'un'}fold`"></i>
    </div>

    <CoverLayout v-if="isShow">
      <div slot="content" class="dialog_QA">
        <i class="circle_top"></i>
        <i class="circle_bottom"></i>
        <i class="icon_close" @click="isShow = false"></i>
        <div class="title">问题与帮助</div>
        <div class="questionTitle">
          <i class="icon_question"></i>
          <div class="question">
            {{ questions[position][current].q }}
          </div>
        </div>
        <div class="answer">
          {{ questions[position][current].a }}
        </div>
        <div class="text_center">
          <Btn btnText="知道了" :width="165" @handleClick="isShow = false" />
        </div>
      </div>
    </CoverLayout>
  </div>
</template>

<script>
import Btn from "./Btn.vue";
import CoverLayout from "./CoverLayout.vue";
export default {
  components: { CoverLayout, Btn },
  props: {
    mainQuestion: {
      type: String,
      default: "为什么可以自填？自填数据的公信力如何保障？"
    },
    position: {
      type: String,
      default: "dataFile"
    },
    showToggle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      flag: false,
      isShow: false,
      current: 0,
      //   questions: [
      //     "为什么可以自填？自填数据的公信力如何保障？",
      //     "第三方采集的数据如何确保个人隐私权利，您的数据档案保存在哪里？",
      //     "第三方采集的数据有误如何处理？"
      //   ],
      questions: {
        dataFile: [
          {
            q: "为什么可以自填？自填数据的公信力如何保障？",
            a:
              "数据档案中展示的所有数据均通过全国人力资源信息数据验证平台收录，数据来源包括自填、国家公信力权威部门、学校/企业/社会机构。您可在此页面查看和自填信息，请您务必仔细核实您自填的各类数据内容，平台再次告知，您对您自填的数据内容负真实可靠性的法律责任，填写/修改记录将永久保留。"
          },
          {
            q: "第三方采集的数据如何确保个人隐私权利，您的数据档案保存在哪里？",
            a:
              "所有第三方合作机构均需获得您同意并授权后通过溯源优才平台采集您的个人信息数据，该数据将存储于溯源优才平台的全国人力资源信息数据验证平台中，所有填写/修改/删除记录将永久保留。您的所有个人信息报告展示以及是否允许他人查验权限等，以您与溯源优才平台个人服务权限设置为准，未经本人授权，任何第三方（包括溯源优才平台管理方）均无法查看。"
          },
          {
            q: "第三方采集的数据有误如何处理？",
            a:
              "您在查询过程中发现第三方采集数据有误时，可通过【勘误申请】按钮向数据采集方举证并提出勘误，第三方核实后进行修正。所有数据变更记录可通过【数据记录】按钮查看。"
          }
        ],
        reportList: [
          {
            q: "个人信息报告如何授权给他人查验？",
            a:
              "您生成个人信息报告后，可通过【查看】进入报告相关操作页面，每份个人信息报告可生成多个授权查验的电子证书，分享电子证书或查验卡片给他人后，他人通过扫码即可查看授权的个人信息报告。"
          },
          {
            q: "数据档案有更新、删除/修改时以往生成的信息报告是否会随着更新？",
            a:
              "个人信息查验报告由溯源优才——全国人力资源信息数据验证平台出具，报告依据截至报告生成时点的全国人力资源信息数据验证平台记录的数据档案生成，未包含此后增删修改的更新数据内容。如需授权他人查验最新数据，需重新生成新的个人信息报告。"
          }
        ],
        reportCheckList: [
          {
            q: "他人如何发起的查验申请？",
            a:
              "他人通过您的真实姓名、手机号向您发起的查验申请，您亦可在查验申请中了解对方真实姓名、手机号，甄别对方用途后决定是否同意并授权其查验。"
          },
          {
            q: "授权个人信息报告删除后，对方是否还能查看？",
            a:
              "授权的个人信息报告在超过可查看次数、超过授权时间、以及删除个人信息报告后，授权失效，对方不可再继续查看授权的个人信息报告。"
          }
        ],
        checkOthers: [
          {
            q: "无法获取对方姓名或者手机号如何查验？",
            a:
              "溯源优才查验他人服务为实名查验服务，无法准确填写对方姓名或手机号，则无法查验他人。"
          },
          {
            q: "发起查验申请后，如何查验对方个人信息报告？",
            a:
              "发起查验申请成功后，平台将通过短信向对方发起查验申请通知，对方登录可同意或拒绝您的查验申请。对方同意并授权查验后，您可以通过【我的查验记录】中点击【查看报告】查验对方授权的个人信息报告。"
          }
        ],
        dataSource: [
          {
            q: "收录时间和采集时间的区别？",
            a:
              "数据收录时间为第三方合作机构收录您信息数据时间点，数据采集时间为溯源优才——全国人力资源信息数据验证平台向第三方合作机构采集相关信息数据时间点。"
          }
        ]
      }
    };
  },
  methods: {
    handleShow(index) {
      this.current = index;
      this.isShow = true;
    }
  }
};
</script>

<style scoped lang="scss">
.text_center {
  text-align: center;
}
.QA {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  //   align-items: center;
  align-items: flex-start;
  margin-bottom: 20px;
  height: 43px;
  z-index: 1;
  .icon_close {
    background: url("../assets/icon_ctu_close.png");
    background-size: cover;
    width: 14px;
    height: 14px;
    display: inline-block;
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
  }
  .icon_question {
    background: url("../assets/icon_question.png");
    background-size: cover;
    width: 13px;
    height: 14px;
    display: inline-block;
    margin-right: 11px;
  }
  .qList {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    position: relative;
    .qItem {
      //   background: #3b61b2;
      margin-right: 10px;
      width: fit-content;
      cursor: pointer;
      margin-bottom: 11px;
      padding: 10px 19px;
      border: 1px solid #e6e6e6;
      border-radius: 18px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #6e6e6e;
      display: flex;
      align-items: center;
    }
    .more {
      position: absolute;
      right: 0px;
      bottom: 22px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #3a61b1;
      cursor: pointer;
    }
  }
  .qToggle {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #3a61b1;
    line-height: 30px;
    padding-right: 3px;
    cursor: pointer;
    .fold {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_arrow_left.png")
        no-repeat;
      background-size: contain;
      width: 7px;
      height: 12px;
      display: inline-block;
      transform: rotate(90deg);
      margin-left: 10px;
    }
    .unfold {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_arrow_left.png")
        no-repeat;
      background-size: contain;
      width: 7px;
      height: 12px;
      display: inline-block;
      transform: rotate(270deg);
      margin-left: 10px;
    }
  }
  .dialog_QA {
    width: 464px;
    // background: url("../assets/ctu_bg.png") no-repeat;
    background: #fff;
    background-size: cover;
    padding: 20px 40px 40px 40px;
    border-radius: 16px;
    box-sizing: border-box;
    position: relative;
    .circle_top {
      background: url("../assets/circle_top.png") no-repeat;
      background-size: cover;
      width: 85px;
      height: 50px;
      display: inline-block;
      position: absolute;
      left: 0;
      top: 0;
    }
    .circle_bottom {
      background: url("../assets/circle_bottom.png") no-repeat;
      background-size: cover;
      width: 103px;
      height: 67px;
      display: inline-block;
      position: absolute;
      right: 0;
      bottom: 0;
    }
    .questionTitle {
      display: flex;
      align-items: baseline;
      .question {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #6e6e6e;
        // line-height: 24px;
        font-weight: 600;
        flex: 1;
      }
    }
    .title {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #3a61b1;
      text-align: center;
      // line-height: 41px;
      margin-bottom: 30px;
    }

    .answer {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #a3a3a3;
      margin-top: 18px;
      margin-bottom: 37px;
      padding-left: 25px;
      line-height: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QA.vue